import { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { actions } from '@redbubble/boom-analytics';

const mapStateToProps = ({ analyticsData }) => ({
  analyticsData
});

const withAnalytics = connect(
  mapStateToProps,
  actions
);

export const useAnalyticsActions = () => {
  const dispatch = useDispatch();

  return useMemo(() => bindActionCreators(actions, dispatch), [
    actions,
    dispatch
  ]);
};

export default withAnalytics;
